import store from "../store";
import router from "../route/router";
import {
  Message,
  Modal
} from "iview";
// axios
import axios from "axios";
// md5
import md5 from "md5";

var loadingId = null;
var util = {
  getInterface: function (name) {
    return store.state.INTERFACE[name];
  },
  md5Str: function (str) {
    return md5(str);
  },
  formatDate: function (time, step, format) {
    // time时间戳 或 yyyy-MM-dd字符串
    if (typeof time === "string") {
      return time ? new Date(time.replace(/-/g, "/")) : new Date();
    } else if (typeof time === "object") {
      return this.formatDate(time.getTime(), step, format);
    }
    time = time || new Date().getTime();
    step = step || 0;
    format = format || "yyyy-MM-dd";
    time = time + step * 24 * 60 * 60 * 1000;
    var date = new Date(time);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    month = month < 10 ? "0" + month : month;
    day = day < 10 ? "0" + day : day;
    if (format === "yyyy-MM-dd hh:mm:ss") {
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      hour = hour < 10 ? "0" + hour : hour;
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    } else {
      return year + "-" + month + "-" + day;
    }
  },
  getWeek: function (date) {
    // date 参数格式 yyyy-MM-dd
    if (!date) return "";
    date = date.substring(0, 10);
    var _date = date.split("-");
    var year = Number(_date[0]);
    var month = Number(_date[1]);
    var day = Number(_date[2]);
    var index = new Date(year, month - 1, day).getDay();
    var indexList = ["日", "一", "二", "三", "四", "五", "六"];
    return "星期" + indexList[index];
  },
  loadingShow: function () {
    setTimeout((_) => {
      loadingId = Message.loading({
        content: "数据加载中...",
        duration: 0,
      });
    });
  },
  loadingHide: function () {
    setTimeout(loadingId);
  },
  openPage: function (options) {
    var type = options.type;
    // var title = options.title
    var id = options.id;
    var menuTabs = store.state.menuTabs;
    var index = -1;
    menuTabs.forEach((item, _index) => {
      if (item.type == type && item.id == id) {
        // 或者item.name === type + '_' + id
        index = _index;
        return false;
      }
    });
    if (index >= 0) {
      // 已在menuTabs中
      store.commit("setActiveMenuTabIndex", index);
    } else {
      options.name = type + "_" + id;
      menuTabs.push(options);
      store.commit("setMenuTabs", menuTabs);
      store.commit("setActiveMenuTabIndex", menuTabs.length - 1);
    }
  },
  closePage: function (options) {
    var type = options.type;
    // var title = options.title
    var id = options.id;
    var menuTabs = store.state.menuTabs;
    var index = -1;
    menuTabs.forEach((item, _index) => {
      if (item.type == type && item.id == id) {
        // 或者item.name === type + '_' + id
        index = _index;
        return false;
      }
    });
    if (index >= 0) {
      // 已在menuTabs中
      menuTabs.splice(index, 1);
      store.commit("setMenuTabs", menuTabs);
      store.commit("setActiveMenuTabIndex", menuTabs.length - 1);
    } else {
      // 不在menuTabs中
      // do nothing
    }
  },
  caringRequest: function (options) {
    setTimeout(() => {
      var headers = {};
      for (var i in options.headers || {}) {
        headers[i] = options.headers[i];
      }
      if (!options.withoutToken) {
        headers.Authorization = "Bearer " + store.state.access_token;
        headers.tenant = store.state.tenant.tenant || ""
        // config.headers["tenant"] = store.state.tenant.tenant || "";
      }

      if (!options.surplusHeader) {
        let addHeader = {
          dept_id: store.state.shift.dept_id || "",
          institution_id: store.state.shift.institution_id || "",
          disease_id: store.state.shift.disease_id || "",
          team_id: store.state.shift.team_id || "",
        };
        headers = Object.assign(addHeader, headers);
      }
      if (options.auth) {
        headers = {
          Authorization: 'Basic Y2hpbmFjYXJpbmc6Y2FyaW5nMjAxNw==',
          hospital: store.state.tenant.tenant || "",
          tenant: store.state.tenant.tenant || ""
        }
        if (store.state.tenant.tenant == 'www') {
          delete headers.hospital;
        }


      }
      // 开始发送请求
      var self = this;
      var method = options.method || options.type || "GET";
      var data = options.data || null;
      var url = options.url || "";
      var params = options.params || {};
      if (typeof data === "string") {
        data = JSON.parse(data);
        for (var key in data) {
          if (data[key] === null) {
            delete data[key];
          }
        }
        if (url === self.getInterface("UNIVERSAL_SELECT") && !data.order_by) {
          data.order_by = "create_time DESC";
        }
        data = JSON.stringify(data);
      } else if (data) {
        if (url === self.getInterface("UNIVERSAL_SELECT")) {
          if (!data.order_by) {
            data.order_by = "create_time DESC";
          } else {
            data.order_by += ",create_time DESC";
          }
        }
      }
      if (method === "GET" && data) {
        let index = 0;
        for (var key in data) {
          url += (index === 0 ? "?" : "&") + key + "=" + data[key];
          index++;
        }
      }
      console.log(188, headers)
      axios({
          method: method,
          url: url,
          asyn: options.asyn || true,
          cache: true,
          headers,
          data,
          params,
          timeout: 15000, // 15s超时
        })
        .then(function (res) {
          if (res.data.code === 30007 || res.data.code === 30006) {
            Message.warning("登录状态过期，请重新登录");
            const route = router.currentRoute;
            store.dispatch("Logout").finally(() => {
              router.replace({
                path: "/user/login",
                query: {
                  redirect: route.fullPath
                }
              });
            });
          }
          var successCallback = options.success || null;
          if (typeof successCallback === "function") {
            successCallback(res.data, res.headers);
          }
        })
        .catch(function (error) {
          self.loadingHide();
          // const timeoutCallback = options.timeout || null
          // if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') >= 0) { // 请求超时
          //     Message.warning('请求超时，请稍后再试')
          //     if (typeof timeoutCallback === 'function') {
          //         timeoutCallback()
          //     }
          //     return
          // }
          // // console.log(error.message)
          // if (error.message.indexOf('Network Error') >= 0) {
          //     if (Date.now() >= Number(store.state.expires_in)) {
          //         console.warn('登录过期啦')
          //         Modal.confirm({
          //             title: '提示',
          //             content: '您的登录信息已过期，请重新登录！',
          //             okText: '立即登录',
          //             cancelText: '暂不登录',
          //             onOk: function() {
          //                 vm.$router.push({
          //                     name: 'login'
          //                 })
          //             }
          //         })
          //     } else {
          //         Message.warning('服务故障，请稍后再试')
          //     }
          //     return
          // }
        });
    }, Math.random() * 1000);
  },
};

export default util;
